import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=12f2af98"
import script from "./RolePermissions.vue?vue&type=script&lang=js"
export * from "./RolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports